<div class="col-md-12 col-sm-12 col-12 shadow" style="padding: 0px;padding: 0px;
border-radius: 10px;
box-shadow: 0 5px 8px rgb(0 0 0 / 20%);">
    <!-- Card -->
    <div class="mainCard brdrRadius3" style="margin-bottom: 50px;"> 
        <!-- Card Header WebView -->
        <div class="mainCardHeader webView" style="vertical-align: middle;">
            <div style="display: inline-block; width: 40%; font-weight: 600; font-size: 20px;">
                Groups & Ledgers
            </div>
            <div style="display: inline-block; width: 60%; text-align: right; line-height: 40px;">
                <!-- <div style="display: inline-block;" *ngIf="isShowSubHeads">
                    <div class="btn btn-blue" (click)="openLedgerModal(ledgerEntry)"
                      style="font-size: 14px; padding: 5px 14px 4px; line-height: 1.66em;">
                      <i class="zmdi zmdi-plus"></i> Add Ledger
                    </div>

                    <div class="btn btn-orange"
                      style="margin-left: 7px; margin-right: 5px; font-size: 14px; padding: 5px 14px 4px; line-height: 1.66em;"
                      (click)="openSubgroupModal(subGroupModal)">
                      <i class="zmdi zmdi-plus"></i> Add Sub-group
                    </div>
                  </div> -->
                <span style="margin-left: 7px;" *ngIf="displayData.length > 0" class="checkbox">
                    <label (change)="clickHideZero()"
                        style="margin-right: 10px; margin-bottom: 0px !important; margin-top: 5px; line-height: 30px; cursor: pointer;">
                        <input type="checkbox" [(ngModel)]="hideZeroLevelLdgr" style="margin-right: 5px;">Hide zeroes
                    </label>
                </span>
                <span class="orangeButton brdrRadius3" style="margin-right: 8px; padding: 3px 2px 3px !important; line-height: 21px;" *ngIf="right.AcctsCfg"
                    (click)="openGroupSubGroup(addmodelopen)" title="Add Ledger / Sub-group">
                    <i class="zmdi zmdi-plus headerIcon" style="font-size: 14px;" aria-hidden="true"></i>
                </span>
                <!-- Head Edit & Delete -->
                <span *ngIf="right.AcctsCfg">
                    <span class="{{!isShowConfig ? 'cfgSettingBtnWeb' : 'darkBlueButton'}} brdrRadius3" style="margin-right: 8px;line-height: 21px;padding: 3px 0px 3px !important;"
                        title="" (click)="changeConfig()" *ngIf="isShowSubHeads">
                        <i class="fa fa-cog headerIcon" aria-hidden="true"></i>
                    </span>
                </span>
                <!-- <span class="btn btn-teal" *ngIf="tree.length > 1" (click)="opeEditDeleetPopup(editGroup, true)" title="Edit / Delete">
                  <i class="fa fa-cog headerIcon" aria-hidden="true"></i>
                </span> -->
                <!--
                  <input type="text" *ngIf="isShowSearch" [(ngModel)]="search" class="form-control wid50"
                    style="width: 20%; display: inline-block;" autofocus />

                  <span class="searchBtn" *ngIf="displayData.length > 0" (click)="isShowSearch = !isShowSearch" title="Search">
                    <i class="fa fa-search headerIcon" aria-hidden="true"></i>
                  </span> -->
                <!-- <span class="expandBtn brdrRadius3" *ngIf="displayData.length > 0" style="padding: 6px 0px;" (click)="openExpandModal(expandModal)"
                    title="Expand">
                    <i class="fa fa-expand headerIcon webView" aria-hidden="true" style="display: inline-block"></i>
                </span> -->
                <span>
                    <i class="fa fa-filter headerIcon" aria-hidden="true"
                        style="margin-right: 0px; color:#795548; display: none;"></i>
                </span>
            </div>
            <div *ngIf="isShowSubHeads">
                <div class="col-md-12 col-sm-12 col-12">
                    <div class="row">
                        <div class="col-md-8 col-sm-8 col-8" style="display: inline-block; padding: 0px;">
                            <div class="tree font13" style="display: inline-block; cursor: pointer;"
                                (click)="allHeads()"> All </div>
                            <div *ngFor="let t of tree; let i = index"
                                style="display: inline-block; cursor: pointer; font-size: 13px;"
                                (click)="treeIndex(t, i,false)">
                                <span style="margin: 0px 5px;"> > </span> <span class="tree">{{t.headName}}</span>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-4 col-4" style="padding: 0px; text-align: right;">
                            <div style="display: inline-block; width: 120px;">
                                <input type="text" *ngIf="isShowSearch" [(ngModel)]="search"
                                    class="form-control font13 " style="width:100%;display: inline-block;" autofocus />
                            </div>
                            <div style="display: inline-block;margin: 6px 4px;">
                                <span class="searchBtn brdrRadius3" *ngIf="displayData.length > 0"
                                    (click)="isShowSearch = !isShowSearch" title="Search">
                                    <i class="fa fa-search headerIcon" aria-hidden="true"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Card Header MobileView-->
        <div class="mainCardHeader mobView" style="vertical-align: middle;">
            <div class="col-md-12 col-sm-12 col-12 pad0">
                <div class="row">
                    <div class="col-md-8 col-sm-8 col-8"
                        style="display: inline-block; width: 40%; font-weight: 600; font-size: 19px;">
                        Groups & Ledgers
                    </div>
                    <div class="col-md-4 col-sm-4 col-4 pad0" style="text-align: center;">
                        <!-- Head Edit & Delete -->
                        <span *ngIf="displayData.length > 0 && right.AcctsCfg">
                            <span
                                class="darkBlueButton brdrRadius3" style="padding: 5px 0px !important; margin-right: 5px;"
                                title="" (click)="changeConfig()" *ngIf="isShowSubHeads">
                                <i class="fa fa-cog headerIcon" aria-hidden="true"></i>
                            </span>
                        </span>
                        <!-- <span class="expandBtn" *ngIf="displayData.length > 0" (click)="openExpandModal(expandModal)"
                            title="Expand">
                            <i class="fa fa-expand headerIcon webView" aria-hidden="true"></i>
                        </span> -->
                        <span class="btn orangeButton brdrRadius3 btnActiveForHead"  style="padding: 3px 0px !important; margin: 0px;" *ngIf="isShowSubHeads && right.AcctsCfg"
                            (click)="openGroupSubGroup(addmodelopen)" title="">
                            <i class="fa fa-plus headerIcon" aria-hidden="true"></i>
                        </span>
                        <span>
                            <i class="fa fa-filter headerIcon" aria-hidden="true"
                                style="margin-right: 0px; color:#795548; display: none;"></i>
                        </span>
                    </div>
                </div>
            </div>

            <div class="col-md-12 col-sm-12 col-12 pad0">
                <div class="row">
                    <div class="col-md-5 col-sm-5 col-5" style="padding: 0px 7px;">
                        <span style="margin-left: 7px;" *ngIf="displayData.length > 0" class="checkbox">
                            <label
                                style="margin-right: 10px; margin-bottom: 0px !important; margin-top: 5px; line-height: 30px; cursor: pointer;">
                                <input type="checkbox" [(ngModel)]="hideZeroLevelLdgr"
                                    style="margin-right: 5px;vertical-align: baseline;">Hide
                                zeroes
                            </label>
                        </span>
                    </div>
                    <div class="col-md-7 col-sm-7 col-7" style="text-align: right; padding: 0px 7px">
                        <div style="display: inline-block; width: 65%;">
                            <input type="text" *ngIf="isShowSearch" [(ngModel)]="search"
                                class="form-control font13 wdth" style="display: inline-block;" autofocus />
                        </div>
                        <div style="display: inline-block;">
                            <span class="searchBtn brdrRadius3" *ngIf="displayData.length > 0"
                                (click)="isShowSearch = !isShowSearch" title="Search">
                                <i class="fa fa-search headerIcon" aria-hidden="true"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12 col-sm-12 col-12" *ngIf="isShowSubHeads" style="margin-top: 10px;">
                <div class="col-md-12 col-sm-12 col-12 pad0">
                    <div class="row">
                        <div class="col-md-8 col-sm-8 col-8" style="display: inline-block; padding: 0px;">
                            <div class="tree font13" style="display: inline-block; cursor: pointer;"
                                (click)="allHeads()"> All </div>
                            <div *ngFor="let t of tree; let i = index"
                                style="display: inline-block; cursor: pointer; font-size: 13px;"
                                (click)="treeIndex(t, i)">
                                <span style="margin: 0px 5px;"> > </span> <span class="tree">{{t.headName}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Card Header -->
        <div class="mainCardBody">
            <div *ngIf="displayData.length > 0">
                <div class="col-md-12 col-sm-12 col-xs-12 pad0"
                    *ngFor="let h of displayData | filter:'name,CloBal':search; let i = index; let l = last;">
                    <div class="mainCardItem" *ngIf="(h.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)"
                        style="{{ i == 0 ? 'border-top: 1px solid #ddd;' : ''}} {{ !l ? 'border-bottom: 1px solid #ddd;' : ''}}">
                        <div class="col-md-6 col-sm-6 col-8 pad0"
                            style="text-align: left; font-size: 13px; display: inline-block; font-weight: {{ h.isHead == true ? '600' : 'normal'}}; cursor: pointer; color: {{ h.isHead == true ? '#15304a' : '#1F628E'}};">
                            <span (click)="openSubHead(h)">{{h.name}}</span>
                            <div *ngIf="isShowConfig" style="display: inline-block;">
                                <i class="fa fa-pencil" (click)="openEditGroupModal(editGroup, h)"
                                    style="margin-left: 10px;" aria-hidden="true"
                                    *ngIf="(h.parentHeadID > 0 && h.isHead == true) || h.isHead == false"></i>
                                <i class="fa fa-trash-o" (click)="deleteGroup(h)" style="margin-left: 10px; color:rgb(114, 96, 96)"
                                    aria-hidden="true"
                                    *ngIf="(h.parentHeadID > 0 && h.isHead == true) || h.isHead == false && h.CloBal == '0.00'"></i>
                                <i class="fa {{h.IsFav ? 'fa-star' : 'fa-star-o'}}" aria-hidden="true"
                                    style="margin-left: 10px; color: #e88421 !important;" *ngIf="h.isHead == false"
                                    (click)=" AddfavLedger(h)"></i>
                                <!-- <i class="fa {{h.isHead==true ? 'fa-trash-o':'none'}};" (click)="deleteGroup(h)"
                                  style="margin-left: 10px; color:gray" *ngIf="h.isHead == true"></i> -->
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-4 pad0 font12"
                            *ngIf="(h.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)"
                            style="text-align: right; display: inline-block; vertical-align: top;">
                            {{h.CloBal | cRDB}}
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="((displayData | filter:'name':search).length === 0) && (displayData.length != 0)">
                <span class="nrf brdrRadius3" style="margin: 10px 15px;">No records found!</span>
            </div>
            <div class="col-md-12" *ngIf="displayData.length == 0">
                <span class="nrf brdrRadius3" *ngIf="right.AcctsCfg" style="margin: 10px 0px;  padding:8px 15px; cursor: pointer;" (click)="openLedgerModal(ledgerEntry, false)">
                    Click here to add a ledger.
                </span>

                <span class="nrf brdrRadius3" *ngIf="!right.AcctsCfg" style="margin: 10px 0px; padding:8px 15px;">
                    No record found.
                </span>
            </div>
        </div>
        <div style="position: absolute; bottom: -40px; left: 0px;" *ngIf="right.AcctsCfg">
            <span class="orangeButton brdrRadius3" style="margin-right: 8px; padding: 4px 10px 4px !important; line-height: 21px;" 
                (click)="openGroupSubGroup(addmodelopen)" title="Add Ledger / Sub-group">
                <i class="zmdi zmdi-plus" style="font-size: 14px;" aria-hidden="true"></i>
                Create Ledger / Sub-Group
            </span>
        </div>
    </div>
</div>
<!--Sub Group Entry Modal-->
<ng-template #subGroupModal let-modal>
    <!--Header-->
    <div class="modal-header">
        <div class="col-md-12 col-sm-12 col-12">
            <div class="row">
                <div class="col-md-9 col-sm-10 col-10" style="padding-left: 0px;">
                    <h4 class="modal-title"><span id="ApntmntHdr">Add Sub-group</span></h4>
                </div>
                <div class="col-md-3 col-sm-2 col-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close" style="float: right;"
                        (click)="modal.dismiss('Cross click')"></i>
                </div>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="modal-body">
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px;font-size: 13px;">
            <div class="col-md-4 col-sm-4 col-4"
                style="padding: 0px; display: inline-block; width: 40%; max-width: 40%; color: #333333;">Parent Group :
            </div>
            <div class="col-md-8 col-sm-8 col-8" style="display: inline-block; width: 60%; padding: 0px;">
                <select class="form-control" [(ngModel)]="newGroup.parantGroupName"
                    style="width: 100%; padding-left: 0px !important;">
                    <option value="0">Select</option>
                    <option *ngFor="let sh of heads" [value]="sh.HeadID">{{sh.HeadName}}</option>
                </select>
            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 10px;font-size: 13px;">
            <div class="col-md-4 col-sm-4 col-4"
                style="padding: 0px; display: inline-block; width: 40%; max-width: 40%; color: #333333;">New Group :
            </div>
            <div class="col-md-8 col-sm-8 col-8" style="display: inline-block; width: 60%; padding: 0px;">
                <input type="text" class="form-control" [(ngModel)]="newGroup.newGroupName" style="width: 100%;">
            </div>
        </div>
    </div>
    <!--Footer-->
    <div class="" style="padding: 15px; border: none; text-align: left; float: left; padding-top: 0px;">
        <span class="btn btn-save brdrRadius3" style="padding: 0px 10px 0px;line-height: 25px;font-size: 13px;" (click)="saveGroup()">
            <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
            <span>Save</span>
        </span>
    </div>
</ng-template>


<!--Ledger Entry Modal-->
<ng-template #ledgerEntry let-modal>
    <!--Header-->
    <div class="modal-header">
        <div class="col-md-12 col-sm-12 col-12">
            <div class="row">
                <div class="col-md-9 col-sm-10 col-10" style="padding-left: 0px;">
                    <h4 class="modal-title"><span id="ApntmntHdr">Add Ledger</span></h4>
                </div>
                <div class="col-md-3 col-sm-2 col-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close" data-dismiss="modal" style="float: right;"
                        (click)="modal.dismiss('Cross click')"></i>
                </div>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="font-size: 13px;">
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px;">
            <div class="col-md-4 col-sm-5 col-5" style="padding: 0px; display: inline-block; color: #333333;">
                Parent Group :
            </div>
            <div class="col-md-7 col-sm-7 col-7" style="display: inline-block; padding: 0px;">
                <select class="form-control wid75 font12 bzInput" [(ngModel)]="newLedger.accountHead"
                    style="padding-left: 0px !important;">
                    <option value="0">Select</option>
                    <option *ngFor="let sh of heads" [value]="sh.HeadID">{{sh.HeadName}}</option>
                </select>
            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
            <div class="col-md-4 col-sm-5 col-5" style="padding: 0px; display: inline-block; color: #333333;">
                Ledger Name :
            </div>
            <div class="col-md-7 col-sm-7 col-7" style="display: inline-block; padding: 0px;">
                <input type="text" class="form-control wid75 font12 bzInput" [(ngModel)]="newLedger.ledgerName" id="txtNewLedger">
            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
            <div class="displayb" style="line-height: 40px; color: #333333; width: 32%;">Link with :
            </div>
            <div class="budge2 btn lableBtnOrange padLeft5 brdrRadius3  hvrInfo btnBottom {{ newLedger.type == 0 ? 'lableBtnOrange-active' : '' }}"
                style="font-size: 13px; margin-left: 0px;" (click)="ledgerType(0)">None</div>
            <div class="budge2 btn lableBtnRed padLeft5 hvrInfo brdrRadius3 btnBottom {{ newLedger.type == 1 ? 'lableBtnYellow-active' : '' }}"
                style="font-size: 13px; margin-left: 0px;" (click)="ledgerType(1)">Customer</div>
            <div class="budge2 btn lableBtGreenMain padLeft5 brdrRadius3 hvrInfo btnBottom {{ newLedger.type == 2 ? 'lableBtGreenMain-active' : '' }}"
                style="font-size: 13px;" (click)="ledgerType(2)">Supplier</div>
            <div class="budge2 btn lableBtTill padLeft5 hvrInfo brdrRadius3 btnBottom {{ newLedger.type == 3 ? 'lableBtTill-active' : '' }}"
                style="font-size: 13px;" (click)="ledgerType(3)">Bank</div>
            <div class="budge2 btn lableBtnDarkBlue padLeft5 brdrRadius3 hvrInfo btnBottom {{ newLedger.type == 4 ? 'lableBtnDarkBlue-active' : '' }}"
                style="font-size: 13px;" (click)="ledgerType(4)">Cash</div>
            <div class="budge2 btn lableBtTill padLeft5 hvrInfo brdrRadius3 btnBottom {{ newLedger.type == 5 ? 'lableBtTill-active' : '' }}"
                style="font-size: 13px; display: none;" (click)="ledgerType(5)">Employee</div>
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;" *ngIf="newLedger.type == 1">
            <div class="col-md-4 col-sm-5 col-4" style="padding: 0px; display: inline-block; color: #333333;">Customer :
            </div>
            <div class="col-md-7 col-sm-7 col-6" style="display: inline-block; padding: 0px;">
                <select class="form-control wid75 font12 bzInput" [(ngModel)]="newLedger.customerId"
                    style="padding-left: 0px !important; cursor: pointer;">
                    <option value="0">Select</option>
                    <option *ngFor="let c of customers | sort : 'Cmp' : 0" [value]="c.RI">
                        {{c.Cmp == '-' ? c.Name : c.Cmp + ' / ' + c.Name}} 
                    </option>
                </select>
                <!-- <input class="form-control wid100" list="customers" [(ngModel)]="newLedger.customerName"
                       placeholder="Select Customer" (blur)="customerChange();">
                <datalist id="customers">
                    <option *ngFor="let c of customers | sort : 'CompanyName' : 0" [value]="c.CompanyName">
                        {{c.CompanyName}}
                    </option>
                </datalist> -->
            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;" *ngIf="newLedger.type == 2">
            <div class="col-md-4 col-sm-5 col-4" style="padding: 0px; display: inline-block; color: #333333;">Supplier :
            </div>
            <div class="col-md-7 col-sm-7 col-6" style="display: inline-block; padding: 0px;">
                <select class="form-control wid75 font12 bzInput" [(ngModel)]="newLedger.supplierId"
                    style="padding-left: 0px !important; cursor: pointer;">
                    <option value="0">Select</option>
                    <option *ngFor="let s of suppliers | sort : 'Cmp' : 0" [value]="s.RI">
                        {{s.Cmp}}</option>
                </select>
                <!-- <input class="form-control wid100" list="supplierList" [(ngModel)]="newLedger.supplierName"
                       placeholder="Select Supplier" (blur)="supplierChange();">
                <datalist id="supplierList">
                    <option *ngFor="let c of suppliers | sort : 'CompanyName' : 0" [value]="c.CompanyName">
                        {{c.CompanyName}}
                    </option>
                </datalist> -->
            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px;" *ngIf="newLedger.type == 3">
            <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
                <div class="col-md-4 col-sm-4 col-4" style="padding: 0px; display: inline-block; color: #333333;">
                    Bank Name :
                </div>
                <div class="col-md-8 col-sm-8 col-6" style="display: inline-block; padding: 0px;">
                    <input type="text" class="form-control font12" [(ngModel)]="bank.name" />
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
                <div class="col-md-4 col-sm-4 col-4" style="padding: 0px; display: inline-block; color: #333333;">Branch
                    :</div>
                <div class="col-md-8 col-sm-8 col-6" style="display: inline-block; padding: 0px;">
                    <input type="text" class="form-control font12" [(ngModel)]="bank.branch" />
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
                <div class="col-md-4 col-sm-4 col-4" style="padding: 0px; display: inline-block; color: #333333;">IFSC :
                </div>
                <div class="col-md-8 col-sm-8 col-6" style="display: inline-block; padding: 0px;">
                    <input type="text" class="form-control font12" [(ngModel)]="bank.ifsc" />
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
                <div class="col-md-4 col-sm-4 col-4" style="padding: 0px; display: inline-block; color: #333333;">
                    Account No :
                </div>
                <div class="col-md-8 col-sm-8 col-6" style="display: inline-block; padding: 0px;">
                    <input type="text" class="form-control font12" [(ngModel)]="bank.accNo" />
                </div>
            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12 nozero"
            style="padding: 0px; margin-top: 15px; cursor: pointer; font-size: 13px; color: #1F628E;"
            *ngIf="!isShowZeroBal" (click)="isShowZeroBal = !isShowZeroBal">
            Set non-zero opening balance
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;" *ngIf="isShowZeroBal">
            <div class="col-md-4 col-sm-3 col-4" style="padding: 0px; display: inline-block; color: #333333;">
                Opening (₹) :
            </div>
            <div class="col-md-3 col-sm-3 col-3" style="display: inline-block; padding-left: 0px;">
                <input type="text" class="form-control" style="text-align: right; width: inherit;"
                    [(ngModel)]="newLedger.openingBal" (keyup)="onlyNumberAlllow()">
            </div>
            <div class="col-md-3 col-sm-3 col-3" style="display: inline-block;">
                <select class="form-control wid75" [(ngModel)]="newLedger.curr" style="padding-left: 0px !important;">
                    <option value="Db">Db</option>
                    <option value="Cr">Cr</option>
                </select>
            </div>
        </div>
    </div>
    <!--Footer-->
    <div class="" style="padding: 15px; border: none; text-align: left; float: left; padding-top: 0px;">
        <span class="btn btn-save brdrRadius3" style="padding: 0px 10px 0px;line-height: 25px;font-size: 13px;" (click)="saveLedger()">
            <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
            <span>Save</span>
        </span>
    </div>
</ng-template>

<!--Expand Modal-->
<ng-template #expandModal let-modal>
    <!--Header-->
    <div class="modal-header">
        <div class="col-md-12 col-sm-12 col-12">
            <div class="row">
                <div class="col-md-9 col-sm-10 col-10" style="padding-left: 0px;">
                    <h4 class="modal-title"><span id="ApntmntHdr">Groups</span></h4>
                </div>
                <div class="col-md-3 col-sm-2 col-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close" data-dismiss="modal" style="float: right;"
                        (click)="modal.dismiss('Cross click')"></i>
                </div>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding-top: 0px; overflow-y: auto;">
        <table mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="name">
                <th class="header" mat-header-cell *matHeaderCellDef style="padding: 0px 10px 0px 0px;">
                    <div class="filter" floatLabel="never" style="width: 90%;">
                        <input matInput class="form-control brdrColor formCtlFltr brdrRadius3" [formControl]="NameFilter" placeholder="Group"
                            style="border: none; border-bottom: 1px solid; font-size: 14px;width: 120px;">
                    </div>
                </th>
                <td mat-cell *matCellDef="let person" style="color: rgb(31, 98, 142)"
                    [ngClass]="{'orangeClr': person.isHead }">
                    {{person.name}}
                </td>
            </ng-container>
            <ng-container matColumnDef="OpBal">
                <th class="header" mat-header-cell *matHeaderCellDef style="padding: 0px 10px;">
                    <div class="filter" floatLabel="never" style="float:right;">
                        <input matInput class="form-control brdrColor formCtlFltr brdrRadius3" [formControl]="OpBalFilter"
                            placeholder="Opening"
                            style="border: none; border-bottom: 1px solid; width: 120px; font-size: 14px;">
                    </div>
                </th>
                <td mat-cell *matCellDef="let person" style="text-align: right;">{{person.OpBal | cRDB}}
                </td>
            </ng-container>
            <ng-container matColumnDef="DbAmt">
                <th class="header" mat-header-cell *matHeaderCellDef style="padding: 0px 10px;">
                    <div class="filter" floatLabel="never" style="float:right;">
                        <input matInput class="form-control brdrColor formCtlFltr brdrRadius3" [formControl]="DbAmtFilter" placeholder="Debit"
                            style="border: none; border-bottom: 1px solid; width: 120px; font-size: 14px;">
                    </div>
                </th>
                <td mat-cell *matCellDef="let person" style="text-align: right;">{{person.DbAmt |
                    cRDB}}</td>
            </ng-container>
            <ng-container matColumnDef="CrAmt">
                <th class="header" mat-header-cell *matHeaderCellDef style="padding: 0px 10px;">
                    <div class="filter" floatLabel="never" style="float:right;">
                        <input matInput class="form-control brdrColor formCtlFltr brdrRadius3" [formControl]="CrAmtFilter" placeholder="Credit"
                            style="border: none; border-bottom: 1px solid; width: 120px; font-size: 14px;">
                    </div>
                </th>
                <td mat-cell *matCellDef="let person" style="text-align: right;">{{person.CrAmt |
                    cRDB}}</td>
            </ng-container>
            <ng-container matColumnDef="CloBal">
                <th class="header" mat-header-cell *matHeaderCellDef style="padding: 0px 10px;">
                    <div class="filter" floatLabel="never" style="float:right;">
                        <input matInput class="form-control brdrColor formCtlFltr brdrRadius3" [formControl]="CloBalFilter"
                            placeholder="Closing"
                            style="border: none; border-bottom: 1px solid; width: 120px; font-size: 14px;">
                    </div>
                </th>
                <td mat-cell *matCellDef="let person" style="text-align: right;">{{person.CloBal |
                    cRDB}}</td>
            </ng-container>
            <ng-container matColumnDef="isHead" style="display: none;">
                <th class="header" mat-header-cell *matHeaderCellDef style="padding: 0px 10px 0px 0px; display: none;">
                    <div class="filter" floatLabel="never" style="width: 90%;">
                        <input matInput class="form-control" [formControl]="NameFilter" placeholder="isHead"
                            style="border: none; border-bottom: 1px solid; font-size: 14px;">
                    </div>
                </th>
                <td mat-cell *matCellDef="let person" style="display: none;">{{person.isHead}}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let person; columns: displayedColumns"></tr>
        </table>
        <div *ngIf="dataSource.filteredData.length === 0">
            <div class="nrf" style="margin-top: 10px;">No records found!</div>
        </div>
    </div>
    <!--Footer-->
    <!-- <div class="" style="padding: 15px; border: none; text-align: left; float: left;">
          <span class="btn btn-save" style="padding: 2px 10px 2px;" (click)="saveLedger()">
              <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
              <span>Save</span>
          </span>
      </div> -->
</ng-template>

<!-- Edit Group/Ledger -->
<ng-template #editGroup let-modal>
    <!--Header-->
    <div class="modal-header">
        <div class="col-md-12 col-sm-12 col-12">
            <div class="row">
                <div class="col-md-9 col-sm-10 col-10" style="padding-left: 0px;">
                    <h4 class="modal-title"><span id="ApntmntHdr">{{ isHeadEdit ? 'Edit Group' : 'Edit Ledger'}}</span>
                    </h4>
                </div>
                <div class="col-md-3 col-sm-2 col-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close" style="float: right;"
                        (click)="modal.dismiss('Cross click')"></i>
                </div>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="font-size: 13px;">
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px;" *ngIf="isHeadEdit">
            <div class="col-md-4 col-sm-3 col-4"
                style="padding: 0px; display: inline-block; max-width: 37%; color: #333333;">
                Group Name :
            </div>
            <div class="col-md-8 col-sm-8 col-8" style="display: inline-block; width: 63%; padding: 0px;">
                <input type="text" class="form-control" [(ngModel)]="newGroup.newGroupName" style="width: 100%;">
            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 10px" *ngIf="!isHeadEdit">
            <div class="col-md-4 col-sm-3 col-4 wid24" style="padding: 0px; display: inline-block; color: #333333;">
                Ledger
                Name :
            </div>
            <div class="col-md-8 col-sm-8 col-8" style="display: inline-block; padding: 0px;">
                <input type="text" class="form-control" [(ngModel)]="newLedger.ledgerName">
            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;" *ngIf="!isHeadEdit">
            <div class="wid24 displayb" style="line-height: 40px; color: #333333;">Link with : </div>
            <div class="budge2 btn lableBtnOrange padLeft5 hvrInfo  brdrRadius3  btnBottom {{newLedger.type == 0 ? 'lableBtnOrange-active' : '' }}"
                style="font-size: 13px; margin-left: 0px;" (click)="ledgerType(0)">None</div>
            <div style="font-size: 13px; margin-left: 0px;"
                class="budge2 btn lableBtnRed  padLeft5 hvrInfo brdrRadius3 btnBottom {{newLedger.type == 1 ? 'lableBtnYellow-active' : '' }}"
                (click)="ledgerType(1)">Customer</div>
            <div style="font-size: 13px;"
                class="budge2 btn lableBtGreenMain padLeft5 hvrInfo brdrRadius3 btnBottom {{newLedger.type == 2 ? 'lableBtGreenMain-active' : '' }}"
                (click)="ledgerType(2)">Supplier</div>
            <div style="font-size: 13px;"
                class=" budge2 btn lableBtTill padLeft5 hvrInfo brdrRadius3 btnBottom  {{newLedger.type == 3 ? 'lableBtTill-active' : '' }}"
                (click)="ledgerType(3)">Bank</div>
            <div style="font-size: 13px;"
                class="budge2 btn lableBtnDarkBlue padLeft5 hvrInfo brdrRadius3 btnBottom {{newLedger.type == 4 ? 'lableBtnDarkBlue-active' : '' }}"
                (click)="ledgerType(4)">Cash</div>
            <div style="font-size: 13px; display: none;"
                class="budge2 btn lableBtTill padLeft5 hvrInfo  brdrRadius3 btnBottom {{newLedger.type == 5 ? 'lableBtTill-active' : '' }}"
                (click)="ledgerType(5)">Employee</div>
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;"
            *ngIf="(newLedger.type == 1) && (!isHeadEdit)">
            <div class="col-md-4 col-sm-4 col-4 wid24" style="padding: 0px; display: inline-block; color: #333333;">
                Customer :
            </div>
            <div class="col-md-8 col-sm-8 col-6" style="display: inline-block; padding: 0px;">
                <select class="form-control wid75" [(ngModel)]="newLedger.customerId"
                    style="padding-left: 0px !important; cursor: pointer;">
                    <option value="0">Select</option>
                    <option *ngFor="let c of customers | sort : 'Cmp' : 0" [value]="c.RI">
                        {{c.Cmp == '-' ? c.Name : c.Cmp + ' / ' + c.Name}} 
                    </option>
                </select>
                <!-- <input class="form-control wid100" list="customers" [(ngModel)]="newLedger.customerName"
                  placeholder="Select Customer" (blur)="customerChange();">
                <datalist id="customers">
                  <option *ngFor="let c of customers | sort : 'CompanyName' : 0" [value]="c.CompanyName">{{c.CompanyName}}
                  </option>
                </datalist> -->
            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;"
            *ngIf="(newLedger.type == 2) && (!isHeadEdit)">
            <div class="col-md-4 col-sm-4 col-4 wid24" style="padding: 0px; display: inline-block; color: #333333;">
                Supplier :
            </div>
            <div class="col-md-8 col-sm-8 col-6" style="display: inline-block; padding: 0px;">
                <select class="form-control wid75" [(ngModel)]="newLedger.supplierId"
                    style="padding-left: 0px !important; cursor: pointer;">
                    <option value="0">Select</option>
                    <option *ngFor="let s of suppliers | sort : 'Cmp' : 0" [value]="s.RI">
                        {{s.Cmp}}</option>
                </select>
                <!-- <input class="form-control wid100" list="supplierList" [(ngModel)]="newLedger.supplierName"
                  placeholder="Select Supplier" (blur)="supplierChange();">
                <datalist id="supplierList">
                  <option *ngFor="let c of suppliers | sort : 'CompanyName' : 0" [value]="c.CompanyName">{{c.CompanyName}}
                  </option>
                </datalist> -->
            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px;" *ngIf="(newLedger.type == 3) && (!isHeadEdit)">
            <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
                <div class="col-md-4 col-sm-4 col-4 wid24" style="padding: 0px; display: inline-block; color: #333333;">
                    Bank
                    Name :
                </div>
                <div class="col-md-8 col-sm-8 col-6" style="display: inline-block; padding: 0px;">
                    <input type="text" class="form-control" [(ngModel)]="bank.name" />
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
                <div class="col-md-4 col-sm-4 col-4 wid24" style="padding: 0px; display: inline-block; color: #333333;">
                    Branch :
                </div>
                <div class="col-md-8 col-sm-8 col-6" style="display: inline-block; padding: 0px;">
                    <input type="text" class="form-control" [(ngModel)]="bank.branch" />
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
                <div class="col-md-4 col-sm-4 col-4 wid24" style="padding: 0px; display: inline-block; color: #333333;">
                    IFSC :
                </div>
                <div class="col-md-8 col-sm-8 col-6" style="display: inline-block; padding: 0px;">
                    <input type="text" class="form-control" [(ngModel)]="bank.ifsc" />
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
                <div class="col-md-4 col-sm-4 col-4 wid24" style="padding: 0px; display: inline-block; color: #333333;">
                    Account
                    No. :
                </div>
                <div class="col-md-8 col-sm-8 col-6" style="display: inline-block; padding: 0px;">
                    <input type="text" class="form-control" [(ngModel)]="bank.accNo" />
                </div>
            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12 nozero"
            style="padding: 0px; margin-top: 15px; cursor: pointer; font-size: 13px; color: #1F628E;"
            *ngIf="!isShowZeroBal && !isHeadEdit" (click)="isShowZeroBal = !isShowZeroBal">
            Set non-zero opening balance
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;"
            *ngIf="isShowZeroBal && !isHeadEdit">
            <div class="col-md-4 col-sm-3 col-4 wid24" style="padding: 0px; display: inline-block; color: #333333;">
                Opening (₹) :
            </div>
            <div class="col-md-3 col-sm-3 col-3" style="display: inline-block; padding-left: 0px;">
                <input type="text" class="form-control" style="text-align: right; width: inherit;"
                    [(ngModel)]="newLedger.openingBal"  (keyup)="onlyNumberAlllow()">
            </div>
            <div class="col-md-3 col-sm-3 col-3" style="display: inline-block;">
                <select class="form-control wid75" [(ngModel)]="newLedger.curr" style="padding-left: 0px !important;">
                    <option value="Db">Db</option>
                    <option value="Cr">Cr</option>
                </select>
            </div>
            <div style="margin-top: 15px; line-height: 18px">
                <span style="font-size: 12px; font-style: italic; color: #808080;">
                    (Note: Changes to the opening balance will be applied from {{acctStartDT}}.)
                </span>
            </div>
        </div>
    </div>
    <!--Footer-->
    <div class="" style="padding: 15px; border: none; text-align: left; float: left; padding-top: 0px;">
        <span *ngIf="isHeadEdit" class="btn btn-save brdrRadius3"
            style="padding: 3px 14px 3px; line-height: 1.66em; font-size: 14px;" (click)="editGroupName()">
            <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
            <span>Save</span>
        </span>
        <span *ngIf="isHeadEdit" class="btn btn-yellow brdrRadius3"
            style="padding: 3px 14px 3px; line-height: 1.66em; font-size: 14px; margin-left: 10px;"
            (click)="deleteHeadFromPopup();">
            <i class="fa fa-trash-o" style="margin-right: 5px;"></i>
            <span>Delete</span>
        </span>
        <span *ngIf="!isHeadEdit" class="btn btn-save brdrRadius3"
            style="padding: 3px 14px 3px; line-height: 1.66em; font-size: 14px;" (click)="editLedgerName()">
            <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
            <span>Save</span>
        </span>
    </div>
</ng-template>

<!--Add New Sub Group Entry Modal-->
<ng-template #addmodelopen let-modal>
    <!--Header-->
    <div class="col-md-12 col-sm-12 col-12 mobAddLed">
        <div class="row">
            <div class="col-md-10 col-sm-10 col-10" style="padding-left: 0px;padding: 15px;">
                <h4 class="modal-title"><span id="ApntmntHdr">What do you wish to add?</span></h4>
            </div>
            <div class="col-md-2 col-sm-2 col-2" style="padding: 15px;">
                <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="modal.dismiss('Cross click')"></i>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="col-md-12 col-sm-12 col-12 mobAddLed webView">
        <div class="row" style="margin-bottom: 15px;">
            <div class="col-md-5 col-sm-6 col-6">
                <div class="orangeButton brdrRadius3" (click)="openLedgerModal(ledgerEntry, false)"
                    style="font-size: 13px; width: 111%;cursor: pointer;margin-left: -4px;">
                    <i class="zmdi zmdi-plus"></i> Add Ledger
                </div>
            </div>
            <div class="col-md-7 col-sm-6 col-6">
                <div class="darkBlueButton brdrRadius3"
                    style="margin-left: 0px;font-size: 13px;width: 100%;cursor: pointer;"
                    (click)="openSubgroupModal(subGroupModal)">
                    <i class="zmdi zmdi-plus"></i> Add Sub-group
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-12 col-sm-12 col-12 mobAddLed mobView">
        <div class="row" style="margin-bottom: 15px;">
            <div class="col-md-12 col-sm-12 col-12" style="padding-bottom: 15px;">
                <div class="btn btn-orange brdrRadius3" (click)="openLedgerModal(ledgerEntry, false)"
                    style="font-size: 14px; padding: 4px 14px 4px;width: 100%;line-height: 1.66em; cursor: pointer;">
                    <i class="zmdi zmdi-plus"></i> Add Ledger
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-12">
                <div class="btn darkBlueButton brdrRadius3"
                    style="margin-left: 0px;font-size: 14px;padding: 4px 14px 4px;width: 100%;line-height: 1.66em; cursor: pointer;"
                    (click)="openSubgroupModal(subGroupModal)">
                    <i class="zmdi zmdi-plus"></i> Add Sub-group
                </div>
            </div>
        </div>
    </div>

</ng-template>
<!-- Admin setting model open-->
<!-- <ng-template #adminsetting let-modal> -->
<!--Header-->
<!-- <div class="col-md-12 col-sm-12 col-12">
    <div class="row">
      <div class="col-md-9 col-sm-10 col-10" style="padding-left: 0px;padding: 10px;">
        <h4 class="modal-title"><span id="ApntmntHdr">select option</span></h4>
      </div>
      <div class="col-md-3 col-sm-2 col-2" style="padding: 10px;">
        <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="modal.dismiss('Cross click')"></i>
      </div>
    </div>
  </div> -->
<!--Body-->
<!-- </ng-template> -->
<mat-spinner style="position: absolute; top: 35%; left: 94%; z-index: 1000;" *ngIf="isShowLoading && false">
</mat-spinner>